import { truncate, stripTrailingSlash } from './stringUtils';

export function formatUrlForDisplay(website) {
    let formattedWebsite = website
        .toLowerCase()
        .replace(/https?:\/\//g, '')
        .replace(/\/$/g, '');

    formattedWebsite = truncate(formattedWebsite, 35);

    if (formattedWebsite === 'www.paragon-re.com') {
        formattedWebsite = null;
    }

    return formattedWebsite;
}

export function formatUrlForHref(website) {
    if (
        website.toLowerCase().includes('https://') ||
        website.toLowerCase().includes('http://')
    ) {
        return website;
    } else {
        return `http://${website}`;
    }
}

export function normalizeCanonicalUrl(url) {
    if (!url) {
        return;
    }

    return stripTrailingSlash(url.toLowerCase());
}



// WEBPACK FOOTER //
// ./src/common/utils/urlUtils.js